import { BUSINESS } from "@/config";
import { Link } from "react-router-dom";
import { WhatsappLogo, Phone, EnvelopeSimple } from "@phosphor-icons/react";

export const Footer = () => {
  const go = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  return (
    <footer className="relative z-10 border-t border-border bg-background pt-16 pb-8" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-2">
              <span className="w-2.5 h-2.5 bg-primary rounded-full" />
              <span className="font-display font-black text-2xl tracking-tighter uppercase">{BUSINESS.name}</span>
            </div>
            <p className="text-muted-foreground text-sm mt-4 max-w-xs leading-relaxed">
              {BUSINESS.tagline} Retail & wholesale tires, expert fitment, honest pricing.
            </p>
          </div>

          <div>
            <div className="text-xs font-bold tracking-[0.2em] uppercase text-muted-foreground mb-4">Explore</div>
            <ul className="space-y-2">
              {[["Search inventory", "#search"], ["Promotions", "#promotions"], ["Wholesale", "#wholesale"], ["Reviews", "#reviews"], ["Visit us", "#location"]].map(([l, h]) => (
                <li key={h}>
                  <button onClick={() => go(h)} className="text-sm text-foreground/70 hover:text-primary transition-colors">{l}</button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="text-xs font-bold tracking-[0.2em] uppercase text-muted-foreground mb-4">Contact</div>
            <ul className="space-y-3 text-sm">
              <li><a href={`tel:${BUSINESS.phoneRaw}`} className="flex items-center gap-2 text-foreground/70 hover:text-primary"><Phone size={16} weight="fill" /> {BUSINESS.phoneDisplay}</a></li>
              <li><a href={`https://wa.me/${BUSINESS.whatsapp}`} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-foreground/70 hover:text-primary"><WhatsappLogo size={16} weight="fill" /> WhatsApp chat</a></li>
              <li><a href={`mailto:${BUSINESS.email}`} className="flex items-center gap-2 text-foreground/70 hover:text-primary"><EnvelopeSimple size={16} weight="fill" /> {BUSINESS.email}</a></li>
              <li className="text-foreground/70 pt-1">{BUSINESS.address}</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-border flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-muted-foreground">© {new Date().getFullYear()} {BUSINESS.name} — All rights reserved.</p>
          <div className="flex items-center gap-4">
            <Link to="/creator" className="text-xs text-muted-foreground hover:text-primary transition-colors" data-testid="footer-creator-link">Creator login</Link>
            <p className="text-xs text-muted-foreground">Built for speed. Priced for the pros.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};
